import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  container: {
    margin: 12,
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
  },
  headerSection: {
    borderWidth: 1,
    borderColor: '#BDC3C7',
    borderRadius: 8,
    padding: 12,
    marginBottom: 10,
    backgroundColor: '#F8F9FA',
  },
  headerTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#2C3E50',
    textAlign: 'center',
    marginBottom: 10,
    textTransform: 'uppercase',
    borderBottomWidth: 1,
    borderBottomColor: '#BDC3C7',
    paddingBottom: 5,
  },
  section: {
    borderWidth: 1,
    borderColor: '#BDC3C7',
    borderRadius: 8,
    padding: 12,
    marginBottom: 10,
    backgroundColor: '#F8F9FA',
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: '#2C3E50',
    textAlign: 'center',
    marginBottom: 8,
    textTransform: 'uppercase',
    borderBottomWidth: 1,
    borderBottomColor: '#BDC3C7',
    paddingBottom: 3,
  },
  dataGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  dataRow: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 10,
    marginBottom: 5,
    alignItems: 'center',
    width: '48%',
  },
  dataRowFull: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 10,
    marginBottom: 5,
    alignItems: 'flex-start',
    width: '100%',
  },
  label: {
    fontWeight: 'bold',
    color: '#2C3E50',
    width: 90,
  },
  value: {
    fontWeight: 500,
    color: '#34495E',
    flex: 1,
  },
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 4,
    fontSize: 9,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  statusPending: {
    backgroundColor: '#FFF3CD',
    color: '#856404',
  },
  statusInProgress: {
    backgroundColor: '#CCE5FF',
    color: '#004085',
  },
  statusDone: {
    backgroundColor: '#D4EDDA',
    color: '#155724',
  },
});
